// Generated by CoffeeScript 2.7.0
var RichTextEditor, tableMenu;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  EditorState,
  Plugin
} from 'prosemirror-state';

import {
  EditorView,
  Decoration,
  DecorationSet
} from "prosemirror-view";

import {
  DOMParser,
  DOMSerializer
} from "prosemirror-model";

import schema from 'trunks/elements/admin/prosemirror/schema.js';

import defaultPlugins from 'trunks/elements/admin/prosemirror/plugins.js';

import {
  pickers,
  buttons
} from 'trunks/elements/admin/prosemirror/menu.js';

import table from 'trunks/elements/admin/prosemirror/table.js';

tableMenu = {
  components: {
    Popover: Popover
  },
  props: {
    editor: {
      required: true
    }
  },
  data: function() {
    return {
      tableOperations: table.commands,
      tableSizeStatus: {
        enableRow: 5,
        enableCol: 6,
        row: 0,
        col: 0
      }
    };
  },
  computed: {
    inTable: function() {
      return this.editor.state && table.active(this.editor.state);
    }
  },
  template: `<Popover customClass="table-button"
         position='bottom center'
         ref="popoverRef">
  <button slot='trigger'>
    <i class="slp-table"></i>
  </button>
  <div class="menu-table-wrapper" slot="content">
    <div class="table-operations" v-if="inTable">
      <div class="operation-group list"
           v-for="(group, key) in tableOperations"
           :key="key">
        <div class="list-item"
             v-for="operation in group"
             @click="tableOperationClicked(operation)">
          {{ operation.content }}
        </div>
      </div>
    </div>
    <div class="create-table" v-else>
      <span>{{ tableSizeStatus.row }}行<span class="ml-2 mr-2">x</span>{{ tableSizeStatus.col }}列</span>
      <table>
        <tbody>
          <tr v-for="row in tableSizeStatus.enableRow"
              :key="'r' + row">
            <td v-for="col in tableSizeStatus.enableCol"
                :key="'c' + col"
                :class="{ 'selected': col <= tableSizeStatus.col && row <= tableSizeStatus.row }"
                @mouseover='showTableSize(row, col)'
                @click='createTable(row, col)'>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</Popover>`,
  methods: {
    showTableSize: function(row, col) {
      this.tableSizeStatus.row = row;
      return this.tableSizeStatus.col = col;
    },
    createTable: function(row, col) {
      table.create(row, col, this.editor.state, this.editor.dispatch, this.editor);
      return this.closePopover();
    },
    tableOperationClicked: function(operation) {
      operation.run(this.editor.state, this.editor.dispatch);
      return this.closePopover();
    },
    closePopover: function() {
      return this.$refs.popoverRef.close();
    }
  }
};

export default RichTextEditor = Vue.extend({
  components: {
    Popover: Popover,
    'table-menu': tableMenu
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    customClass: {
      type: [String, Array]
    },
    params: {
      type: Object,
      default: function() {
        return {};
      }
    },
    menuSticky: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      editor: {},
      menu: {
        pickers: pickers,
        buttons: buttons
      }
    };
  },
  template: `<div class="slp-rich-text-editor" :class='customClass'>
  <div v-sticky="{ className: 'sticky-content', style: { zIndex: 11, left: 'auto', right: 'auto' }, disabled: !menuSticky, stickyInContent: 'slp-rich-text-editor' }">
    <div class="menubar">
      <Popover :customClass="['pm-picker', key + '-picker']"
              position='bottom center'
              :caret="false"
              v-for="(dropdown, key) in menu.pickers"
              :key="key"
              :ref="key + 'PopoverRef'">
        <button class="pm-picker-label" slot='trigger'>
          <i :class="menuIcon(dropdown.icon)" :style="menuIconColor(dropdown)"></i>
          <i class="slp-caret-down"></i>
        </button>
        <div class="pm-picker-options" slot="content">
          <div class="pm-picker-item"
              :class="menuItemClass(child, key)"
              v-for="child in dropdown.children"
              @click="menuItemClicked($event, child, key)"
              v-html="child.content">
          </div>
        </div>
      </Popover>
      <button v-for="(button ,key) in menu.buttons"
              :class="menuItemClass(button, key)"
              :key="key"
              @click="menuItemClicked($event, button)">
        <i :class="menuIcon(button.icon)"></i>
      </button>
      <table-menu :editor='editor'></table-menu>
    </div>
  </div>
  <div class="rich-text-editor" ref='container'>
  </div>
  <div style="display: none;" v-html="value" ref="content"></div>
</div>`,
  mounted: function() {
    return this.editor = this.createEditorView();
  },
  methods: {
    createEditorState: function(content) {
      var plugins;
      plugins = defaultPlugins.concat(this.placeholderPlugin(this.placeholder));
      return EditorState.create({
        schema,
        doc: content,
        plugins: plugins
      });
    },
    createEditorView: function() {
      var state;
      state = this.createEditorState(this.getInitialDoc());
      return new EditorView(this.$refs.container, {
        state: state,
        dispatchTransaction: this.dispatchTransaction.bind(this)
      });
    },
    getInitialDoc: function() {
      return DOMParser.fromSchema(schema).parse(this.$refs.content);
    },
    getValue: function() {
      var fragment, tmp;
      fragment = DOMSerializer.fromSchema(schema).serializeFragment(this.editor.state.doc.content);
      tmp = document.createElement("div");
      tmp.appendChild(fragment);
      return tmp.innerHTML;
    },
    clearContent: function() {
      var emptyContent, state;
      emptyContent = schema.nodeFromJSON({
        type: 'doc',
        content: [
          {
            type: 'paragraph'
          }
        ]
      });
      state = this.createEditorState(emptyContent);
      return this.editor.updateState(state);
    },
    dispatchTransaction: function(tr) {
      var newState;
      if (!tr) {
        return;
      }
      newState = this.editor.state.apply(tr);
      this.editor.updateState(newState);
      return this.$emit('valueChanged', this.getValue());
    },
    menuIcon: function(icon) {
      return `slp-${icon}`;
    },
    menuItemClass: function(menuItem, key) {
      var ref;
      return {
        [ref = `pm-${key}`]: ref,
        'pm-active': this.editor.state && menuItem.active && menuItem.active(this.editor.state),
        'disabled': this.editor.state && menuItem.enable && !menuItem.enable(this.editor.state)
      };
    },
    menuIconColor: function(dropdown) {
      if (!dropdown.active) {
        return;
      }
      return {
        color: dropdown.active
      };
    },
    menuItemClicked: function(ev, menuItem, key) {
      var ispicker, ref;
      ispicker = Boolean(key);
      if (!ispicker && ev.target.closest('button').classList.contains('disabled')) {
        return;
      }
      menuItem.run(this.editor.state, this.editor.dispatch, this.editor);
      ispicker && ((ref = this.$refs[`${key}PopoverRef`][0]) != null ? ref.close() : void 0); // close popover
      return this.editor.focus();
    },
    placeholderPlugin: function(text) {
      return new Plugin({
        props: {
          decorations: function(state) {
            var doc, placeholder;
            doc = state.doc;
            if (doc.childCount === 1 && doc.firstChild.isTextblock && doc.firstChild.content.size === 0) {
              placeholder = document.createElement('div');
              placeholder.classList.add('placeholder');
              placeholder.textContent = text;
              return DecorationSet.create(doc, [Decoration.widget(1, placeholder)]);
            }
          }
        }
      });
    }
  }
});
